import { Box, CircularProgress, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { getData } from "./UtilityFunctions";

export default function ImageLoader(props) {
  const {
    alt,
    imageFile,
    imageFileId,
    imageCache,
    fileSize,
    wrapperSx,
    imageSx,
    background,
    avatar,
  } = props;
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(null);
  const theme = useTheme();

  const fetchFile = async (fileId) => {
    if (!fileId) return;

    if (imageCache) {
      if (!imageCache[fileSize || 0]) {
        imageCache[fileSize || 0] = {};
      }
      if (imageCache[fileSize || 0][fileId]) {
        return imageCache[fileSize || 0][fileId];
      }
    }

    var returnObj;
    try {
      returnObj = await getData(`/files/${fileId}`, {
        queryStringParameters: {
          size: fileSize,
        },
      });

      if (imageCache) {
        imageCache[fileSize || 0][fileId] = returnObj;
      }
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const loadImage = async () => {
    setLoading(true);
    if (!imageFileId) {
      setImage({
        url: `${getEnvironmentVariable(
          "SYSTEM_IMAGES_CLOUDFRONT"
        )}/images/EventImage${theme?.palette?.mode === "dark" ? "Dark" : ""}.png`,
      });

      return;
    }

    if (image) {
      if (image.id === imageFileId) {
        return;
      }
      setImage(null);
    }

    try {
      var file = imageFile ? imageFile : await fetchFile(imageFileId);
      if (file) {
        setImage({
          id: imageFileId,
          ...file,
        });
      }
    } catch (err) {
      //
    }
  };

  useEffect(() => {
    loadImage();
    // eslint-disable-next-line
  }, [imageFileId]);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        // height: "calc(100vw / 16 * 9)",
        justifyContent: "center",
        alignItems: "center",
        ...(background && {
          flexBasis: "100%",
          flexGrow: 0,

          ...(image?.url && {
            background: `url(${image?.url})`,
          }),

          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }),
        ...(avatar && {
          borderRadius: "50%",
          overflow: "hidden",
        }),
        ...wrapperSx,
      }}
    >
      {image?.url && (
        <img
          src={image.url}
          alt={alt}
          style={{
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%",
            ...imageSx,
            ...(background && {
              display: "none",
            }),
          }}
          onLoad={() => setLoading(false)}
        />
      )}

      {loading && (
        <Box
          sx={{
            width: "100%",
            position: "relative",
            textAlign: "center",
            top: background ? "calc(50% - 25px)" : "calc(-50% - 25px)",
          }}
        >
          <CircularProgress size={50} />
        </Box>
      )}
    </Box>
  );
}
